import { StubPage } from '../components/StubPage';

export function DutyCalcPage(): JSX.Element {
  return <StubPage navKey="dutyCalc" />;
}
